import React from 'react';
function Divider() {
	return (
		<hr className='border-coolGray-100 py-10 relative max-w-container mx-auto flex items-center justify-center' />
	);
}

export default Divider;
